var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isEqual } from 'lodash';
export var handleMultiRemoveOption = function (_a) {
    var rowOption = _a.rowOption, value = _a.value, handleOnChange = _a.handleOnChange;
    var copyArr = value.slice(0);
    var index = copyArr.findIndex(function (x) { return isEqual(rowOption, x); });
    copyArr.splice(index, 1);
    handleOnChange(copyArr);
};
export var handleMultiAddOption = function (_a) {
    var rowOption = _a.rowOption, value = _a.value, handleOnChange = _a.handleOnChange;
    handleOnChange(__spreadArray(__spreadArray([], value, true), [rowOption], false));
};
